// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Amount,
    AmountFromJSON,
    AmountToJSON,
    ProviderClaimPaymentItem,
    ProviderClaimPaymentItemFromJSON,
    ProviderClaimPaymentItemToJSON,
    ProviderCollectionInvoiceDraftDiscount,
    ProviderCollectionInvoiceDraftDiscountFromJSON,
    ProviderCollectionInvoiceDraftDiscountToJSON,
    ProviderCollectionInvoiceDraftLineItemWithPaymentsItem,
    ProviderCollectionInvoiceDraftLineItemWithPaymentsItemFromJSON,
    ProviderCollectionInvoiceDraftLineItemWithPaymentsItemToJSON,
    ProviderCollectionInvoiceDraftPayment,
    ProviderCollectionInvoiceDraftPaymentFromJSON,
    ProviderCollectionInvoiceDraftPaymentToJSON,
    ProviderCollectionInvoiceDraftValidationMessage,
    ProviderCollectionInvoiceDraftValidationMessageFromJSON,
    ProviderCollectionInvoiceDraftValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderCollectionInvoiceDraftPreview
 */
export interface ProviderCollectionInvoiceDraftPreview {
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    collectionInvoiceDraftId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    collectionInvoiceIntegrationId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    billingProviderId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    memo?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    externalPatientId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    patientFirstName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    patientMiddleName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    patientLastName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    patientDateOfBirth?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    patientEmail?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    patientPhone?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    patientAddress1?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    patientAddress2?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    patientCity?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    patientState?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    patientZip?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    externalGuarantorId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    externalGuarantorOrganizationId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    guarantorFirstName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    guarantorLastName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    guarantorOrganizationName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    guarantorDateOfBirth?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    guarantorEmail?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    guarantorPhone?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    guarantorAddress1?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    guarantorAddress2?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    guarantorCity?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    guarantorState?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    guarantorZip?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    controlNumber?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    facilityName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    facilityId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    renderingProviderFirstName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    renderingProviderLastName?: string;
    /**
     * 
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    selfPay?: boolean;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    primaryPayerName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    primaryInsurancePlanName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    primaryInsuranceMemberId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    secondaryPayerName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    secondaryInsurancePlanName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    secondaryInsuranceMemberId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    tertiaryPayerName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    tertiaryInsurancePlanName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    tertiaryInsuranceMemberId?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    invoiceAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    patientPayments?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    patientDiscounts?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    currentBalance?: Amount;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    approveDate?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    approvedByBankUserId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    approveNotes?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    denyDate?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    deniedByBankUserId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    denyNotes?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    claimId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    claimBundleId?: string;
    /**
     * 
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    active?: boolean;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    createDate?: string;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderClaimPaymentItem>}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    unmatchedPaymentItems?: Array<ProviderClaimPaymentItem>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderCollectionInvoiceDraftLineItemWithPaymentsItem>}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    invoiceDraftItems?: Array<ProviderCollectionInvoiceDraftLineItemWithPaymentsItem>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderCollectionInvoiceDraftDiscount>}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    discounts?: Array<ProviderCollectionInvoiceDraftDiscount>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderCollectionInvoiceDraftPayment>}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    payments?: Array<ProviderCollectionInvoiceDraftPayment>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderCollectionInvoiceDraftValidationMessage>}
     * @memberof ProviderCollectionInvoiceDraftPreview
     */
    validationMessages?: Array<ProviderCollectionInvoiceDraftValidationMessage>;
}

export function ProviderCollectionInvoiceDraftPreviewFromJSON(json: any): ProviderCollectionInvoiceDraftPreview {
    return {
            'collectionInvoiceDraftId': !exists(json, 'collectionInvoiceDraftId') ? undefined : json['collectionInvoiceDraftId'],
            'collectionInvoiceIntegrationId': !exists(json, 'collectionInvoiceIntegrationId') ? undefined : json['collectionInvoiceIntegrationId'],
            'billingProviderId': !exists(json, 'billingProviderId') ? undefined : json['billingProviderId'],
            'memo': !exists(json, 'memo') ? undefined : json['memo'],
            'externalPatientId': !exists(json, 'externalPatientId') ? undefined : json['externalPatientId'],
            'patientFirstName': !exists(json, 'patientFirstName') ? undefined : json['patientFirstName'],
            'patientMiddleName': !exists(json, 'patientMiddleName') ? undefined : json['patientMiddleName'],
            'patientLastName': !exists(json, 'patientLastName') ? undefined : json['patientLastName'],
            'patientDateOfBirth': !exists(json, 'patientDateOfBirth') ? undefined : json['patientDateOfBirth'],
            'patientEmail': !exists(json, 'patientEmail') ? undefined : json['patientEmail'],
            'patientPhone': !exists(json, 'patientPhone') ? undefined : json['patientPhone'],
            'patientAddress1': !exists(json, 'patientAddress1') ? undefined : json['patientAddress1'],
            'patientAddress2': !exists(json, 'patientAddress2') ? undefined : json['patientAddress2'],
            'patientCity': !exists(json, 'patientCity') ? undefined : json['patientCity'],
            'patientState': !exists(json, 'patientState') ? undefined : json['patientState'],
            'patientZip': !exists(json, 'patientZip') ? undefined : json['patientZip'],
            'externalGuarantorId': !exists(json, 'externalGuarantorId') ? undefined : json['externalGuarantorId'],
            'externalGuarantorOrganizationId': !exists(json, 'externalGuarantorOrganizationId') ? undefined : json['externalGuarantorOrganizationId'],
            'guarantorFirstName': !exists(json, 'guarantorFirstName') ? undefined : json['guarantorFirstName'],
            'guarantorLastName': !exists(json, 'guarantorLastName') ? undefined : json['guarantorLastName'],
            'guarantorOrganizationName': !exists(json, 'guarantorOrganizationName') ? undefined : json['guarantorOrganizationName'],
            'guarantorDateOfBirth': !exists(json, 'guarantorDateOfBirth') ? undefined : json['guarantorDateOfBirth'],
            'guarantorEmail': !exists(json, 'guarantorEmail') ? undefined : json['guarantorEmail'],
            'guarantorPhone': !exists(json, 'guarantorPhone') ? undefined : json['guarantorPhone'],
            'guarantorAddress1': !exists(json, 'guarantorAddress1') ? undefined : json['guarantorAddress1'],
            'guarantorAddress2': !exists(json, 'guarantorAddress2') ? undefined : json['guarantorAddress2'],
            'guarantorCity': !exists(json, 'guarantorCity') ? undefined : json['guarantorCity'],
            'guarantorState': !exists(json, 'guarantorState') ? undefined : json['guarantorState'],
            'guarantorZip': !exists(json, 'guarantorZip') ? undefined : json['guarantorZip'],
            'controlNumber': !exists(json, 'controlNumber') ? undefined : json['controlNumber'],
            'facilityName': !exists(json, 'facilityName') ? undefined : json['facilityName'],
            'facilityId': !exists(json, 'facilityId') ? undefined : json['facilityId'],
            'renderingProviderFirstName': !exists(json, 'renderingProviderFirstName') ? undefined : json['renderingProviderFirstName'],
            'renderingProviderLastName': !exists(json, 'renderingProviderLastName') ? undefined : json['renderingProviderLastName'],
            'selfPay': !exists(json, 'selfPay') ? undefined : json['selfPay'],
            'primaryPayerName': !exists(json, 'primaryPayerName') ? undefined : json['primaryPayerName'],
            'primaryInsurancePlanName': !exists(json, 'primaryInsurancePlanName') ? undefined : json['primaryInsurancePlanName'],
            'primaryInsuranceMemberId': !exists(json, 'primaryInsuranceMemberId') ? undefined : json['primaryInsuranceMemberId'],
            'secondaryPayerName': !exists(json, 'secondaryPayerName') ? undefined : json['secondaryPayerName'],
            'secondaryInsurancePlanName': !exists(json, 'secondaryInsurancePlanName') ? undefined : json['secondaryInsurancePlanName'],
            'secondaryInsuranceMemberId': !exists(json, 'secondaryInsuranceMemberId') ? undefined : json['secondaryInsuranceMemberId'],
            'tertiaryPayerName': !exists(json, 'tertiaryPayerName') ? undefined : json['tertiaryPayerName'],
            'tertiaryInsurancePlanName': !exists(json, 'tertiaryInsurancePlanName') ? undefined : json['tertiaryInsurancePlanName'],
            'tertiaryInsuranceMemberId': !exists(json, 'tertiaryInsuranceMemberId') ? undefined : json['tertiaryInsuranceMemberId'],
            'invoiceAmount': !exists(json, 'invoiceAmount') ? undefined : AmountFromJSON(json['invoiceAmount']),
            'patientPayments': !exists(json, 'patientPayments') ? undefined : AmountFromJSON(json['patientPayments']),
            'patientDiscounts': !exists(json, 'patientDiscounts') ? undefined : AmountFromJSON(json['patientDiscounts']),
            'currentBalance': !exists(json, 'currentBalance') ? undefined : AmountFromJSON(json['currentBalance']),
            'approveDate': !exists(json, 'approveDate') ? undefined : json['approveDate'],
            'approvedByBankUserId': !exists(json, 'approvedByBankUserId') ? undefined : json['approvedByBankUserId'],
            'approveNotes': !exists(json, 'approveNotes') ? undefined : json['approveNotes'],
            'denyDate': !exists(json, 'denyDate') ? undefined : json['denyDate'],
            'deniedByBankUserId': !exists(json, 'deniedByBankUserId') ? undefined : json['deniedByBankUserId'],
            'denyNotes': !exists(json, 'denyNotes') ? undefined : json['denyNotes'],
            'claimId': !exists(json, 'claimId') ? undefined : json['claimId'],
            'claimBundleId': !exists(json, 'claimBundleId') ? undefined : json['claimBundleId'],
            'active': !exists(json, 'active') ? undefined : json['active'],
            'createDate': !exists(json, 'createDate') ? undefined : json['createDate'],
            'unmatchedPaymentItems': !exists(json, 'unmatchedPaymentItems') ? undefined : (json['unmatchedPaymentItems'] as Array<any>).map(ProviderClaimPaymentItemFromJSON),
            'invoiceDraftItems': !exists(json, 'invoiceDraftItems') ? undefined : (json['invoiceDraftItems'] as Array<any>).map(ProviderCollectionInvoiceDraftLineItemWithPaymentsItemFromJSON),
            'discounts': !exists(json, 'discounts') ? undefined : (json['discounts'] as Array<any>).map(ProviderCollectionInvoiceDraftDiscountFromJSON),
            'payments': !exists(json, 'payments') ? undefined : (json['payments'] as Array<any>).map(ProviderCollectionInvoiceDraftPaymentFromJSON),
            'validationMessages': !exists(json, 'validationMessages') ? undefined : (json['validationMessages'] as Array<any>).map(ProviderCollectionInvoiceDraftValidationMessageFromJSON),
    };

}

export function ProviderCollectionInvoiceDraftPreviewToForm(value?: ProviderCollectionInvoiceDraftPreview): any {
    let jsonVal = ProviderCollectionInvoiceDraftPreviewToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function ProviderCollectionInvoiceDraftPreviewToJSON(value?: ProviderCollectionInvoiceDraftPreview): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'collectionInvoiceDraftId': cleanupBlankValuesForBackend(value.collectionInvoiceDraftId),
            'collectionInvoiceIntegrationId': cleanupBlankValuesForBackend(value.collectionInvoiceIntegrationId),
            'billingProviderId': cleanupBlankValuesForBackend(value.billingProviderId),
            'memo': cleanupBlankValuesForBackend(value.memo),
            'externalPatientId': cleanupBlankValuesForBackend(value.externalPatientId),
            'patientFirstName': cleanupBlankValuesForBackend(value.patientFirstName),
            'patientMiddleName': cleanupBlankValuesForBackend(value.patientMiddleName),
            'patientLastName': cleanupBlankValuesForBackend(value.patientLastName),
            'patientDateOfBirth': cleanupBlankValuesForBackend(value.patientDateOfBirth),
            'patientEmail': cleanupBlankValuesForBackend(value.patientEmail),
            'patientPhone': cleanupBlankValuesForBackend(value.patientPhone),
            'patientAddress1': cleanupBlankValuesForBackend(value.patientAddress1),
            'patientAddress2': cleanupBlankValuesForBackend(value.patientAddress2),
            'patientCity': cleanupBlankValuesForBackend(value.patientCity),
            'patientState': cleanupBlankValuesForBackend(value.patientState),
            'patientZip': cleanupBlankValuesForBackend(value.patientZip),
            'externalGuarantorId': cleanupBlankValuesForBackend(value.externalGuarantorId),
            'externalGuarantorOrganizationId': cleanupBlankValuesForBackend(value.externalGuarantorOrganizationId),
            'guarantorFirstName': cleanupBlankValuesForBackend(value.guarantorFirstName),
            'guarantorLastName': cleanupBlankValuesForBackend(value.guarantorLastName),
            'guarantorOrganizationName': cleanupBlankValuesForBackend(value.guarantorOrganizationName),
            'guarantorDateOfBirth': cleanupBlankValuesForBackend(value.guarantorDateOfBirth),
            'guarantorEmail': cleanupBlankValuesForBackend(value.guarantorEmail),
            'guarantorPhone': cleanupBlankValuesForBackend(value.guarantorPhone),
            'guarantorAddress1': cleanupBlankValuesForBackend(value.guarantorAddress1),
            'guarantorAddress2': cleanupBlankValuesForBackend(value.guarantorAddress2),
            'guarantorCity': cleanupBlankValuesForBackend(value.guarantorCity),
            'guarantorState': cleanupBlankValuesForBackend(value.guarantorState),
            'guarantorZip': cleanupBlankValuesForBackend(value.guarantorZip),
            'controlNumber': cleanupBlankValuesForBackend(value.controlNumber),
            'facilityName': cleanupBlankValuesForBackend(value.facilityName),
            'facilityId': cleanupBlankValuesForBackend(value.facilityId),
            'renderingProviderFirstName': cleanupBlankValuesForBackend(value.renderingProviderFirstName),
            'renderingProviderLastName': cleanupBlankValuesForBackend(value.renderingProviderLastName),
            'selfPay': cleanupBlankValuesForBackend(value.selfPay),
            'primaryPayerName': cleanupBlankValuesForBackend(value.primaryPayerName),
            'primaryInsurancePlanName': cleanupBlankValuesForBackend(value.primaryInsurancePlanName),
            'primaryInsuranceMemberId': cleanupBlankValuesForBackend(value.primaryInsuranceMemberId),
            'secondaryPayerName': cleanupBlankValuesForBackend(value.secondaryPayerName),
            'secondaryInsurancePlanName': cleanupBlankValuesForBackend(value.secondaryInsurancePlanName),
            'secondaryInsuranceMemberId': cleanupBlankValuesForBackend(value.secondaryInsuranceMemberId),
            'tertiaryPayerName': cleanupBlankValuesForBackend(value.tertiaryPayerName),
            'tertiaryInsurancePlanName': cleanupBlankValuesForBackend(value.tertiaryInsurancePlanName),
            'tertiaryInsuranceMemberId': cleanupBlankValuesForBackend(value.tertiaryInsuranceMemberId),
            'invoiceAmount': AmountToJSON(value.invoiceAmount),
            'patientPayments': AmountToJSON(value.patientPayments),
            'patientDiscounts': AmountToJSON(value.patientDiscounts),
            'currentBalance': AmountToJSON(value.currentBalance),
            'approveDate': cleanupBlankValuesForBackend(value.approveDate),
            'approvedByBankUserId': cleanupBlankValuesForBackend(value.approvedByBankUserId),
            'approveNotes': cleanupBlankValuesForBackend(value.approveNotes),
            'denyDate': cleanupBlankValuesForBackend(value.denyDate),
            'deniedByBankUserId': cleanupBlankValuesForBackend(value.deniedByBankUserId),
            'denyNotes': cleanupBlankValuesForBackend(value.denyNotes),
            'claimId': cleanupBlankValuesForBackend(value.claimId),
            'claimBundleId': cleanupBlankValuesForBackend(value.claimBundleId),
            'active': cleanupBlankValuesForBackend(value.active),
            'createDate': cleanupBlankValuesForBackend(value.createDate),
            'unmatchedPaymentItems': (value.unmatchedPaymentItems === undefined || value.unmatchedPaymentItems === null) ? undefined : (value.unmatchedPaymentItems as Array<any>).map(ProviderClaimPaymentItemToJSON),
            'invoiceDraftItems': (value.invoiceDraftItems === undefined || value.invoiceDraftItems === null) ? undefined : (value.invoiceDraftItems as Array<any>).map(ProviderCollectionInvoiceDraftLineItemWithPaymentsItemToJSON),
            'discounts': (value.discounts === undefined || value.discounts === null) ? undefined : (value.discounts as Array<any>).map(ProviderCollectionInvoiceDraftDiscountToJSON),
            'payments': (value.payments === undefined || value.payments === null) ? undefined : (value.payments as Array<any>).map(ProviderCollectionInvoiceDraftPaymentToJSON),
            'validationMessages': (value.validationMessages === undefined || value.validationMessages === null) ? undefined : (value.validationMessages as Array<any>).map(ProviderCollectionInvoiceDraftValidationMessageToJSON),
    };
}


